import { render, staticRenderFns } from "./ComposicaoDaReceitaDeVendaDeAnimaisAbsoluto.vue?vue&type=template&id=06b4b9c8&scoped=true&"
import script from "./ComposicaoDaReceitaDeVendaDeAnimaisAbsoluto.vue?vue&type=script&lang=js&"
export * from "./ComposicaoDaReceitaDeVendaDeAnimaisAbsoluto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b4b9c8",
  null
  
)

export default component.exports